// Core types and enums
export {
  RobotTypeEnum,
  RobotModelEnum,
  RobotManufacturerEnum,
} from './types';
export type {
  RobotModelConfig,
} from './types';

// Registry
export {
  ROBOT_MODEL_CONFIGS,
  getModelConfig,
} from './registry';

// Hooks (moved to hooks/statekeeping)
export { useRobotIdentity, useIsWearable } from 'hooks/statekeeping';
export type { RobotIdentity } from 'hooks/statekeeping';
export { useLocation } from 'hooks/statekeeping';
export type { GpsCoordinates } from 'hooks/statekeeping';
export { useBattery } from 'hooks/statekeeping';
export type { RobotBatteryInfo } from 'hooks/statekeeping';

// Robot state telemetry (common for all robots)
export { useRobotState, useIsArmed, useRobotLocation, useRobotBattery } from './telemetry/robot-state/hooks';

// Aerial telemetry
export { useAerialState } from './telemetry/aerial/hooks';
export {
  aerialFlightModeToString,
  fixTypeToString,
  isAerialFlying,
  canAerialLand,
  canAerialTakeoff,
} from './telemetry/aerial/types';

